(function (otherWorkView, $) {
  var slider;

  otherWorkView.init = function () {
    if ($(".el-slideshow").length > 0) {
      // This is commented out for now, as we use the photo grid instead. Might re-instate in future.
      slider = tns({
        container: ".el-slideshow",
        /*fixedWidth:200,*/
        autoWidth: false /* because we want 2 slides shown at once at times */,
        slideBy: 1,
        items: 1,
        //autoplay: true, // on the product detail page, autoplay seems to go haywire after dragging with mouse, so keep it off
        autoplayTimeout: 1000,
        autoplayHoverPause: true,
        controls: false,
        nav: false /* This turns off the nav dots */,
        autoplayButtonOutput: "",
        lazyload: false,
        mouseDrag: true,
        responsive: {
          1240: { items: 4 },
          768: { items: 3 },
          600: { items: 2 },
        },
        /*lazyloadSelector:'.inspired__image'*/
        /*center:true,*/
        /*mouseDrag:true*/ /* MouseDrag doesn't work very well when the items are anchor linked */
      });

      var dragMeHandWritingIsVisible = true;
      slider.events.on("indexChanged", function () {
        if (dragMeHandWritingIsVisible) {
          dragMeHandWritingIsVisible = false;
          $(".other-work-drag-handwriting").transit({ opacity: 0 }, 500);
        }
      });
    }

    wireEvents();
  };

  function wireEvents() {
    var aFx = 60,
      trF = 4;
    $(".js-tilt-image")
      .on("mousemove", function (e) {
        var cH = $(this).closest(".photo").innerHeight(),
          cW = $(this).closest(".photo").innerWidth(),
          eX = e.offsetX,
          eY = e.offsetY;

        TweenMax.set(this, {
          transformOrigin:
            (eX / (cW * trF) / 100) * 10000 + trF * 10 + "% " + ((eY / (cH * trF) / 100) * 10000 + trF * 10) + "%",
          transformPerspective: 1500,
        });
        TweenMax.to(this, 0.5, {
          rotationX: (eY - cH / 2) / aFx,
          rotationY: (eX - cW / 2) / aFx,
          y: (eY - cH / 2) / 70,
          x: (eX - cW / 2) / 70,
        });
      })
      .on("mouseout", function () {
        TweenMax.to(this, 1, {
          delay: 0.2,
          y: 0,
          x: 0,
          rotationX: 0,
          rotationY: 0,
          transformPerspective: "1500",
        });
      });
  }
})((window.el.OtherWorkView = window.el.OtherWorkView || {}), jQuery);
